var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",attrs:{"type":_vm.type || 'button',"disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('UiLoading'):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }